"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// eslint-disable-next-line func-names, consistent-return
var _default = function () {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    // eslint-disable-next-line no-param-reassign
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  window.CustomEvent = CustomEvent;
}();

exports.default = _default;